import { Component, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit, OnChanges {
  private map: L.Map | null = null;
  private marker: L.Marker | null = null;

  // Inputs para las coordenadas y zoom
  @Input() lat: number = 0;
  @Input() lng: number = 0;
  @Input() zoom: number = 13;
  @Input() markerText: string = 'Ubicación';
  @Input() draggable: boolean = false;

  ngAfterViewInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.map && (changes.lat || changes.lng)) {
      this.updateMarker();
    }
  }

  private initMap(): void {
    // Crear el mapa si no existe
    if (!this.map) {
      this.map = L.map('map').setView([this.lat, this.lng], this.zoom);

      // Añadir capa de tiles (OpenStreetMap)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      this.addMarker();
    }
  }

  private addMarker(): void {
    if (!this.map) return;

    // Crear icono personalizado
    const icon = L.icon({
      iconUrl: 'assets/images/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      //shadowUrl: 'assets/images/marker-shadow.png',
      shadowSize: [41, 41]
    });

    // Añadir marcador
    this.marker = L.marker([this.lat, this.lng], {
      icon,
      draggable: this.draggable
    }).addTo(this.map);

    // Añadir popup
    this.marker.bindPopup(`<b>${this.markerText}</b><br>Lat: ${this.lat.toFixed(4)}<br>Lng: ${this.lng.toFixed(4)}`);

    // Manejar eventos si es draggable
    if (this.draggable) {
      this.marker.on('dragend', (event) => {
        const newPos = (event.target as L.Marker).getLatLng();
        console.log('Nueva posición:', newPos);
      });
    }
  }

  private updateMarker(): void {
    if (!this.map || !this.marker) return;

    this.marker.setLatLng([this.lat, this.lng]);
    this.map.setView([this.lat, this.lng], this.zoom);
    this.marker.setPopupContent(`<b>${this.markerText}</b><br>Lat: ${this.lat.toFixed(4)}<br>Lng: ${this.lng.toFixed(4)}`);
  }

  public setView(lat: number, lng: number, zoom?: number): void {
    if (this.map) {
      this.map.setView([lat, lng], zoom || this.zoom);
    }
  }
}